module.exports = __webpack_public_path__ + "static/media/stop.1ed29636.mp3";